import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Spin } from 'antd';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';

const { Meta } = Card;

const Team = () => {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTeam();
  }, []);

  useEffect(() => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // agar instant chahiye to is line ko hata do
  });
}, []);
  const fetchTeam = async () => {
    try {
      const response = await api.get('/team_members');
      if (response.data.success) {
        setTeam(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching team:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-page">
      <Helmet>
        <title>Our Team - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
      
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mb-5">
                <div className="divider-simple text-center">
                  <h3>Our Team</h3> 
                  <p className="team-title">
  Meet the talented people behind our success
</p>
                </div>
              </div>
            </div>
          </div>
          
          {loading ? (
            <div className="text-center">
              <Spin size="large" />
            </div>
          ) : (
            <Row gutter={[24, 24]}>
              {team.map(member => (
                <Col key={member.id} xs={24} sm={12} md={8} lg={6}>
              <Card
  hoverable
  cover={
    member.profile_image ? (
      <img 
        alt={member.name}
        src={`https://www.businessmateworkflow.in/uploads/cms/${member.profile_image.split('uploads/').pop()}`}
        style={{
          width: '100%',         // Ensures the image fills the card width
             
          objectFit: 'cover',    // Crops image nicely without distortion
        }}
      />
    ) : null
  }
>
  <Meta
    title={member.name}
    description={member.position}
  />
  <div className="mt-3" dangerouslySetInnerHTML={{ __html: member.bio }} />
</Card>

                </Col>
              ))}
            </Row>
          )}
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Team;